import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { MyContext } from "../../Context/MyProvider";
import { showToast } from "../../showTost";
import { FiPlus, FiTrash2, FiEdit2 } from "react-icons/fi";

export default function MedicineReminderList() {
  const { ApiBaseUrl, setIsLoginShow } = useContext(MyContext);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const Userid = secureLocalStorage.getItem("Userid");

  const load = () => {
    if (!Userid) {
      setIsLoginShow(true);
      setLoading(false);
      return;
    }
    setLoading(true);
    axios
      .post(`${ApiBaseUrl}/customer/medicince_reminder_list`, { id: Userid })
      .then((r) => {
        setList(r.data.remider_list || []);
      })
      .catch(() => showToast({ title: "Could not load reminders", id: "error" }))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
  }, [Userid, ApiBaseUrl]);

  const handleDelete = (reminderId) => {
    if (!window.confirm("Delete this medicine reminder?")) return;
    axios
      .post(`${ApiBaseUrl}/customer/delete_medicince_reminder`, {
        id: Userid,
        reminder_id: reminderId,
      })
      .then((r) => {
        showToast({ title: r.data.message || "Deleted", id: "success" });
        load();
      })
      .catch(() => showToast({ title: "Delete failed", id: "error" }));
  };

  return (
    <div className="max-w-3xl mx-auto px-4 py-8">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold text-rm-ink">Medicine Reminder</h1>
          <p className="text-gray-600 text-sm">Never miss a dose — schedule daily reminders.</p>
        </div>
        <button
          className="bg-[#0d9488] text-white px-4 py-2 rounded-lg flex items-center gap-2"
          onClick={() => navigate("/dashbord/medicine-reminder/add")}
        >
          <FiPlus /> Add
        </button>
      </div>

      {loading ? (
        <p className="text-center text-gray-500 py-10">Loading…</p>
      ) : list.length === 0 ? (
        <div className="text-center py-16 border rounded-xl bg-white">
          <p className="font-medium text-lg">No drugs schedule</p>
          <p className="text-gray-500 mt-1">Add your first medicine reminder.</p>
          <button
            className="mt-4 bg-[#0d9488] text-white px-4 py-2 rounded-lg"
            onClick={() => navigate("/dashbord/medicine-reminder/add")}
          >
            Add medicine
          </button>
        </div>
      ) : (
        <div className="space-y-3">
          {list.map((item) => {
            const times = Array.isArray(item.time)
              ? item.time
              : typeof item.time === "string"
                ? JSON.parse(item.time || "[]")
                : [];
            return (
              <div key={item.id} className="border rounded-xl p-4 bg-white flex justify-between gap-3">
                <div>
                  <h3 className="font-semibold text-lg">{item.medicine_name}</h3>
                  <p className="text-sm text-gray-600 mt-1">
                    {times.map((t) => t.title || t.time).filter(Boolean).join(" · ") || "No times"}
                  </p>
                  <p className="text-xs mt-2">
                    Status:{" "}
                    <span className={String(item.status) === "1" ? "text-green-600" : "text-gray-500"}>
                      {String(item.status) === "1" ? "Active" : "Paused"}
                    </span>
                  </p>
                </div>
                <div className="flex flex-col gap-2">
                  <button
                    className="p-2 rounded bg-gray-100 hover:bg-gray-200"
                    onClick={() =>
                      navigate("/dashbord/medicine-reminder/add", {
                        state: {
                          reminderId: item.id,
                          medicineName: item.medicine_name,
                          timedata: times,
                          status: item.status,
                        },
                      })
                    }
                  >
                    <FiEdit2 />
                  </button>
                  <button
                    className="p-2 rounded bg-red-50 text-red-600 hover:bg-red-100"
                    onClick={() => handleDelete(item.id)}
                  >
                    <FiTrash2 />
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
